import React from 'react'
import { useTranslation } from 'react-i18next'
import { convertApiTimeToString } from '../../../helpers/time/convertApiTime'
import { getEventsAddressPostfix } from '../../shipment/EditShipment/editShipmentUtils'

const ShipmentEvent = ({event}) => {
  const {t, i18n} = useTranslation()
  
  if(!event) {
    return <></>
  }

  return (
    <div className='flex flex-col text-left gap p-2 bg-gray-100 rounded-xl'>
        <span className='text-base flex flex-wrap items-center gap-x-2'>
          <span className='font-semibold'>{t("shipments.shipment_events.date")}: </span>
          <span className='font-light text-base'>{convertApiTimeToString(event.time, i18n.language)}</span>
        </span>

        <span className='text-base flex items-start gap-x-2'>
          <span className='font-semibold'>{t("shipments.shipment_events.event")}: </span>
          <div className='flex flex-col gap-1'>
            <span className='text-base' style={{wordBreak: "break-word"}}>{event.headline[getEventsAddressPostfix(i18n.language)]}</span>
            <span className='text-sm' style={{wordBreak: "break-word"}}>{event.description[getEventsAddressPostfix(i18n.language)]}</span>
          </div>
        </span>
    </div>
  )
}

export default ShipmentEvent